// Recovered compiled webpack factory 75477. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { default: () => i });
  var a = r(12115),
    n = {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    },
    l = r(84375);
  let s = (0, a.createContext)({}),
    i = (0, a.forwardRef)((e, t) => {
      let {
          color: r,
          size: i,
          strokeWidth: d,
          absoluteStrokeWidth: o,
          className: c = "",
          children: u,
          iconNode: f,
          ...m
        } = e,
        {
          size: p = 24,
          strokeWidth: x = 2,
          absoluteStrokeWidth: h = !1,
          color: b = "currentColor",
          className: g = "",
        } = (0, a.useContext)(s) ?? {},
        y = (o ?? h) ? (24 * Number(d ?? x)) / Number(i ?? p) : (d ?? x);
      return (0, a.createElement)(
        "svg",
        {
          ref: t,
          ...n,
          width: i ?? p ?? n.width,
          height: i ?? p ?? n.height,
          stroke: r ?? b,
          strokeWidth: y,
          className: (0, l.z)("lucide", g, c),
          ...(!u &&
            !((e) => {
              for (let t in e)
                if (t.startsWith("aria-") || "role" === t || "title" === t) return !0;
              return !1;
            })(m) && { "aria-hidden": "true" }),
          ...m,
        },
        [
          ...f.map((e) => {
            let [t, r] = e;
            return (0, a.createElement)(t, r);
          }),
          ...(Array.isArray(u) ? u : [u]),
        ],
      );
    });
}
